var Pixel = Pixel || {};

Pixel.Nanigans = (function (PixelBase) {
	var Nanigans = PixelBase.extend({
		initialize: function (opts) {
			opts = opts || {};
			opts.getUserID && (this._getUserID = opts.getUserID);
			this._currency = opts.currency;
		},

		registrationView: function () {
			this._track(['visit', 'landing']);
        },

		registrationSuccess: function () {
			this._trackWithUserID(['install', 'reg']);
        },

        purchaseSuccess: function (opts) {
	        opts = opts || {};
	        this._trackWithUserID(['purchase', 'main', opts.pricesArr, {
	        	sku: opts.productIDsArr,
	        	qty: opts.qtyArr,
        		unique: opts.orderNo,
        		currency: this._currency
	        }]);
        },

        _getAPI: function() {
            return this._api || window.NaN_api;
        },

        _track: function () {
        	return this._applyPush([this._id], arguments);
        },

        _trackWithUserID: function () {
        	return this._applyPush([this._id, this._getUserID()], arguments);
        },

		_applyPush: function(params, args) {
			var api = this._getAPI();
			return api.push.apply(api, [params].concat(_.toArray(args)));
		},

		_getUserID: function() {}
    });

    return Nanigans;
})(Pixel.PixelBase);

!function (Pixel, app, GlobalSettings) {
    if (!GlobalSettings.NAE) {
        return;
    }

    window.NaN_api = [];

    (function () {
        var s = document.createElement('script');
        s.async = true;
        s.src = '//cdn.nanigans.com/NaN_tracker.js';
        var h = document.getElementsByTagName('head')[0];
        h.appendChild(s);
    })();

    new Pixel.Nanigans({
    	id: GlobalSettings.NAI,
    	currency: GlobalSettings.Currency,
		getUserID: function() {
			return app.cookie.get('v');
		}
    });
}(Pixel, app, app.GlobalSettings);
